import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { db } from "../firebase";
import Statusbar from "../body_root/statusbar";
import Lodinging from "../components_root/loading.jsx";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext";
import { MdAdd, MdCalendarMonth, MdCall, MdDataset, MdDelete, MdDeleteOutline, MdEdit, MdEmail, MdLink, MdShare } from "react-icons/md";
import CountryCodeSelect from "../body_root/CountryCodeSelect";
import { addDoc, collection, query, where, onSnapshot, getDocs, deleteDoc, doc, orderBy } from "firebase/firestore";
import { Save_note_message } from "./save_note_message";
export const seo = {
    title: "Free Online Phonebook | Manage Personal Contacts Easily - Viabig",
    description:
        "Create and manage your personal phonebook online for free with Viabig. Add, edit, and organize contacts with categories, mobile numbers, and more. Simple, secure, and easy to use.",
    keywords:
        "free phonebook, online phonebook, manage contacts online, personal phonebook, free contact manager, digital phonebook, viabig phonebook",
    url: "https://viabig.com/phonebook",
    image: "https://viabig.com/assets/logo.png",
};

export default function Phonebook_Contact({ data = {} }) {
    const navigate = useNavigate();
    const { Toastshow } = Toast();

    // Prefill state from data
    const [category, setCategory] = useState(data.category || "");
    const [name, setName] = useState(data.cname || "");
    const [countrycode, setCountryCode] = useState(data.countrycode || "+91");
    const [mobilenumber, setMobileNumber] = useState(data.mobilenumber || "");
    const [phonenumber, setPhoneNumber] = useState(data.phonenumber || "");
    const [reference_number, setReferenceNumber] = useState(data.reference_number || "");
    const [address, setAddress] = useState(data.address || "");
    const [city, setCity] = useState(data.city || "");
    const [state, setState] = useState(data.state || "");
    const [country, setCountry] = useState(data.country || "");
    const [showMore, setShowMore] = useState(false);
    const [phonebookData, setPhonebookData] = useState([]);
    const [phonebook_note_remaderdata, setPhonebook_note_remaderData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoading2, setIsLoading2] = useState(true);
    const [note_message, setNote_message] = useState("");
    const [owner, setOwner] = useState(false);
    const [guid, setguid] = useState('');
    const [islogin, setIslogin] = useState(false);
    useEffect(() => {
        const existingsessiontoken = Cookies.get("sessiontoken");
        if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
            setIslogin(true);
            setguid(Cookies.get("guid"));
        }
    }, [navigate]);

    useEffect(() => {
        const fetchData = async () => {
            if (!data) return;
            const phonebookQuery = query(
                collection(db, "phonebook"),
                where("uid", "==", data.uid)
            );
            const snapshot = await getDocs(phonebookQuery);
            const docs = await Promise.all(
                snapshot.docs.map(async (docSnap) => {
                    const docData = docSnap.data();
                    const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                    let child = {};
                    fieldsSnap.forEach((fieldDoc) => {
                        const { fieldName, fieldValue } = fieldDoc.data();
                        child[fieldName] = fieldValue;
                    });
                    return { uid: docSnap.id, ...docData, child };
                })
            );
            if (docs[0].guid == Cookies.get("guid")) {

                setOwner(true);
            }
            setPhonebookData(docs);
        };

        fetchData();
    }, [data]);

    const handleSave = async () => {
        try {
            // TODO: save to Firestore here
            Toastshow("Contact saved successfully!");
        } catch (err) {
            console.error("Save error:", err);
            Toastshow("Failed to save contact.");
        }
    };
    const handleShare = async () => {
        const url = "/" + data.uid;
        if (navigator.share) {
            try {
                await navigator.share({
                    url,
                });
                console.log("Content shared successfully");
            } catch (error) {

            }
        } else {

        }
    };

    const post_note_message = async () => {
        if (!note_message) return Toastshow("Please note_message");
        if (!data.uid) return Toastshow("Please contact not fund");
        try {
            const result = await Save_note_message({
                note_message,
                pbuid: data.uid
            });

            if (result.success) {
                Toastshow("Post saved successfully!");
                setNote_message("");
                fetch_phonebook_note_remader();
            } else {
                Toastshow("Error: " + (result.error || "Unknown error"));
            }
        } catch (error) {
            console.error("❌ Error submitting post:", error);
            Toastshow("Error submitting post: " + error.message);
        }
    };

    //
    const fetch_phonebook_note_remader = async () => {
        setIsLoading2(true);
        try {
            const phonebookQuery = query(
                collection(db, "phonebook_note_remader"),
                where("pbuid", "==", data.uid),
                where("guid", "==", Cookies.get("guid"),
                    orderBy("date_time", "desc"))
            );

            const userSnapshot = await getDocs(phonebookQuery);
            const dataList = userSnapshot.docs.map((doc) => ({
                uid: doc.id,
                ...doc.data(),
            }));

            setPhonebook_note_remaderData(dataList);
        } catch (err) {
            console.error("Error fetching phonebook_note_remader:", err);
        }
        setIsLoading2(false);
    };
    useEffect(() => {
        fetch_phonebook_note_remader();
    }, []);
    const set_delete = async (uid) => {
        if (uid) {   // ✅ only delete if uid exists
            try {
                const docRef = doc(db, "phonebook_note_remader", uid);
                await deleteDoc(docRef); // ✅ correct Firestore delete function
                Toastshow("Deleted successfully");
                fetch_phonebook_note_remader(); // refresh data
            } catch (error) {
                console.error("Error deleting document:", error);
                Toastshow("Delete failed");
            }
        } else {
            Toastshow("Value is null");
        }
    };
    return (
        <div>
            <Statusbar data="Contact" />
            <Helmet>
                <title>{phonebookData[0]?.child?.name || seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={phonebookData[0]?.child?.name || seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size">
                    <div className="container_size_mobile">
                        <div className="ui-grid-fill">
                            {phonebookData.map((row) => (
                                <div className="p-1 ui-items items-back border" key={row.uid}>
                                    <table>
                                        <tbody>
                                            <tr onClick={() => navigate("/" + row.uid)} className="border-bottom">
                                                <td className="text-h2 bold">{row?.child?.name}</td>
                                                <td className="balance-column">
                                                    <a className="fcap text-h2 text-off">{row?.category}</a>
                                                </td>
                                            </tr>
                                            {row?.child?.mobilenumber && (
                                                <tr>
                                                    <td onClick={() => navigate("/" + row.uid)} className="text-off">Mobile</td>
                                                    <td  >
                                                        <table>
                                                            <tr>
                                                                <td onClick={() => navigate("/" + row.uid)}>  <a className="text-h2 bold"  >
                                                                    {row?.child?.countrycode || ""}{row?.child?.mobilenumber || ""}
                                                                </a>
                                                                </td>

                                                                <td width={25}>
                                                                    <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.mobilenumber || ""}`}>
                                                                        <MdCall className="icon cursor" /></a>
                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>
                                                </tr>
                                            )}


                                            {row?.child?.phonenumber && (
                                                <tr>
                                                    <td className="text-off">Phone</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.phonenumber || ""}`}>
                                                                    {row?.child?.countrycode || ""}{row?.child?.phonenumber || ""}
                                                                </a>
                                                                </td>

                                                                <td width={25}>
                                                                    <a className="text-h2 bold" href={`tel:${row?.child?.countrycode || ""}${row?.child?.phonenumber || ""}`}>
                                                                        <MdCall className="icon cursor" /></a>
                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.emailid && (
                                                <tr>
                                                    <td className="text-off">Email ID</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h2 bold"  >
                                                                    {row.child?.emailid || ""}

                                                                </a>
                                                                </td>

                                                                <td width={25}>
                                                                  <a
  className="text-h2 bold"
  href={row?.child?.emailid ? `mailto:${row.child.emailid}` : "#"}
>
  <MdEmail className="icon" />
</a>
                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.website && (
                                                <tr>
                                                    <td className="text-off">Website</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h2 bold"  >
                                                                    {row.child?.website || ""}

                                                                </a>
                                                                </td>

                                                                <td width={25}>
                                                                    <a
                                                                        className="text-h2 bold"
                                                                        href={row?.child?.website ? `${row.child.website}` : "#"}
                                                                        target="_blank"
                                                                        rel="noopener noreferrer"
                                                                    >
                                                                        <MdLink className="icon" />
                                                                    </a>

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.reference_number && (
                                                <tr>
                                                    <td className="text-off">R/F/H/No</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h2 bold"  >
                                                                    {row.child?.reference_number || ""}

                                                                </a>
                                                                </td>

                                                                <td width={25}>

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.address && (
                                                <tr>
                                                    <td className="text-off">Address</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <div className="fcaps text-h3">
                                                                    {row.child?.address || ""}

                                                                </div>
                                                                </td>

                                                                <td width={25}>

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.city && (
                                                <tr>
                                                    <td className="text-off">City</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h3"  >
                                                                    {row.child?.city || ""}

                                                                </a>
                                                                </td>

                                                                <td width={25}>

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.state && (
                                                <tr>
                                                    <td className="text-off">State</td>
                                                    <td >

                                                        <table></table>
                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h3"  >
                                                                    {row.child?.state || ""}

                                                                </a>
                                                                </td>

                                                                <td width={25}>

                                                                </td>
                                                            </tr>
                                                        </table>

                                                    </td>

                                                </tr>
                                            )}
                                            {row?.child?.country && (
                                                <tr>
                                                    <td className="text-off">Country</td>
                                                    <td>


                                                        <table>
                                                            <tr>
                                                                <td>  <a className="text-h3"  >
                                                                    {row.child?.country || ""}
                                                                </a>
                                                                </td>
                                                                <td width={25}>
                                                                </td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td className="text-off">Created</td>
                                                <td>
                                                    {row.date_time?.toDate
                                                        ? `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                                                        : "No data"}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td className="text-off">Update</td>
                                                <td>
                                                    {row.date_time_update?.toDate
                                                        ? `${row.date_time_update.toDate().toLocaleDateString()} ${row.date_time_update.toDate().toLocaleTimeString()}`
                                                        : "No data"}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>
                        <br />
                        <table>
                            <tr>
                                <td>
                                    {owner ? (
                                        <div>
                                            <div className="button-ui2 fill" onClick={() => navigate("/phonebook-edit?uid=" + data.uid)}>
                                                <MdEdit className="icon" /> Edit
                                            </div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div className="button-ui2 fill" >
                                                <MdAdd className="icon" /> Save
                                            </div>
                                        </div>
                                    )}

                                </td>
                                <td>
                                    <div className="button-ui2 fill" onClick={handleShare}>
                                        <MdShare className="icon" /> Share
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <br />  <br />
                    <div className="post-container">
                        <div className="post_updates">

                            {islogin ? (
                                <div >
                                    <table>
                                        <tr>
                                            <td>
                                                <textarea
                                                    maxLength={2000}
                                                    className="text-h2 bold"
                                                    placeholder="Enter note"
                                                    value={note_message}
                                                    onChange={(e) => {
                                                        setNote_message(e.target.value);

                                                        // Auto resize
                                                        e.target.style.height = "auto";   // reset height
                                                        e.target.style.height = e.target.scrollHeight + "px"; // set new height
                                                    }}
                                                    style={{ overflow: "hidden", resize: "none" }} // clean UI
                                                />
                                            </td>
                                        </tr>

                                    </table>
                                    <table>
                                        <tr>
                                            <td>
                                                <table>
                                                    <tr>
                                                        <td width={24}>
                                                            <div className="text-h2" ><MdCalendarMonth className="icon" /></div></td>
                                                        <td ><div className="text-h2  cursor">  Set Remader</div></td>
                                                    </tr>
                                                </table>
                                            </td>
                                            <td className="text-off text-h2" width={30}>{2000 - note_message.length}</td>
                                            <td width={30}><div onClick={post_note_message} className="button-ui rounded"><MdAdd className="icon" /></div></td>
                                        </tr>

                                    </table>
                                </div>
                            ) : (
                                <div>
                                    <div className="button-ui rounded"><MdAdd className="icon" />Login Your account</div>
                                </div>
                            )}
                            <br />
                        </div>
                        <div className="post_div">
                            {isLoading2 ? (
                                <Lodinging />
                            ) : phonebook_note_remaderdata.length === 0 ? (
                                <div className="text-h1 text-off center p-1">
                                    No note data found.<br />
                                    Create a free note and enjoy managing your personal contacts note !
                                </div>
                            ) : (
                                <div className="ui-grid">
                                    {[...phonebook_note_remaderdata].reverse().map((row, index) => (


                                        <div className="p-1 ui-items items-back border" key={row.id || index}>
                                            <table>
                                                <tbody>
                                                    <tr className="border-bottom ">
                                                        <td > <div className="button-ui2 rounded">{index + 1}</div> </td>
                                                        <td width={160} className="balance-columntext-h3 text-off "> {row.date_time?.toDate
                                                            ? `${row.date_time.toDate().toLocaleDateString()} ${row.date_time.toDate().toLocaleTimeString()}`
                                                            : "No data"}<br /><div className="text-h3 text-off">ID: {row?.uid}</div></td>
                                                        <td width={24}> <div onClick={() => set_delete(row?.uid)} className="button-ui2 rounded"><MdDeleteOutline className="icon" /></div> </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div className="text-h2 ">{row?.note_message || "No message"}</div>
                                        </div>

                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
